<template>
    <transition name="el-zoom-in-top">
        <el-dialog :title="title" :visible.sync="show" width="60%" :close-on-click-modal="false"
            :modal-append-to-body='true'>
            <!-- 填写基础信息 -->
            <el-form ref="receipForm" :model="receipForm" label-width="120px" style="width: 90%" :rules="rules">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="生产工单" prop="orderNo">
                            <el-select filterable style="width: 100%;" v-model="receipForm.orderNo"
                                placeholder="请选择生产工单">
                                <el-option v-for="item in workList" :label="`${item.orderno} ${item.product_name}`"
                                    :key="item.orderno" :value="item.orderno" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="产品" prop="productCode">
                            <el-select v-model.trim="receipForm.productCode" placeholder="请输入产品名称" style="width:100%"
                                filterable>
                                <el-option v-for="item in productlistdata" :key="item.product_code"
                                    :label="item.product_name" :value="item.product_code" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="入库数量" prop="quantity">
                            <el-input v-model.number="receipForm.quantity" style="width: 100%" placeholder="请输入入库数量" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="单位" prop="unitCode">
                            <el-select v-model="receipForm.unitCode" placeholder="请输入单位名称" style="width:100%"
                                filterable>
                                <el-option v-for="item in productunitpagelist" :key="item.product_unit_code"
                                    :label="item.product_unit_cn" :value="item.product_unit_code" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="仓库" prop="warehouseCode">
                            <el-select v-model.trim="receipForm.warehouseCode" placeholder="请输入仓库名称" style="width:100%"
                                filterable>
                                <el-option v-for="item in pagewarehouse" :key="item.warehouseCode"
                                    :label="item.warehouseName" :value="item.warehouseCode" />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="入库类型" prop="receiptType">
                            <el-select v-model="receipForm.receiptType" placeholder="请选择入库类型">
                                <el-option label="生产入库" :value="1"></el-option>
                                <el-option label="调拨入库" :value="2"></el-option>
                                <el-option label="退货入库" :value="3"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="入库日期" prop="plan_date" label-width="120px">
                            <el-date-picker style="width: 100%" v-model="receipForm.receiptDate" type="date"
                                value-format="yyyy-MM-dd" placeholder="选择入库日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div style="text-align: center">
                <el-button style="margin-top: 12px" @click="resetForm()">取消</el-button>
                <el-button style="margin-top: 12px" @click="submitadd('receipForm')" type="primary">提交</el-button>
            </div>
        </el-dialog>
    </transition>
</template>
<script>
import {
    receiptUpdate, receiptAdd, receiptDetail
} from "@/api/production";
import { productlist, productunitpagelist, } from "@/api/base";
import { pagewarehouse } from "@/api/query";
import {
    orderquery,
} from "@/api/plant";

export default {
    data() {
        return {
            reality_instorage: 0,
            row: {},
            tableData: [],
            //基础数据
            show: false,
            receipForm: {},
            title: '新增入库',
            workList: [],
            productlistdata: [],
            productunitpagelist: [],
            pagewarehouse: [],
            rules: {
                orderNo: [
                    { required: true, message: "请选择工单", trigger: "change" },
                ],
                productCode: [
                    { required: true, message: "请选择产品", trigger: "blur" },
                ],
                quantity: [
                    { required: true, message: "请输入数量", trigger: "blur" },
                ],
                warehouseCode: [
                    { required: true, message: "请选择仓库", trigger: "blur" },
                ],
                receiptDate: [
                    { required: true, message: "请选择入库时间", trigger: "blur" },
                ],
                unitCode: [
                    { required: true, message: "请选择单位", trigger: "blur" },
                ],
                receiptType: [
                    { required: true, message: "请选择入库类型", trigger: "blur" },
                ],
            },
        };
    },
    methods: {
        // 修改明细
        getoutbilldata(row) {
            this.title = '编辑入库'
            // this.receipForm = Object.assign({}, row);
            receiptDetail(row.id).then(res => {
                console.log(res, 'res');
                this.receipForm = res.data
                this.receipForm.workorderSeniorOrder = String(this.receipForm.workorderSeniorOrder)
                console.log(this.receipForm, '11111');
            })

        },
        //保存提交
        submitadd(formName) {
            this.$refs[formName].validate(valid => {
                //基础表单验证
                if (valid) {
                    if (this.receipForm.id) {
                        receiptUpdate({
                            ...this.receipForm,
                            receiptSource: 1
                        }).then(response => {
                            this.$message({
                                type: "success",
                                message: "修改成功!"
                            });
                            this.resetForm("receipForm");
                            this.$parent.search();
                        });

                    } else {
                        receiptAdd({
                            ...this.receipForm,
                            receiptSource: 1
                        }).then(response => {
                            this.$message({
                                type: "success",
                                message: "提交成功!"
                            });
                            this.resetForm("receipForm");
                            this.$parent.search();
                        });
                    }

                }
            });
        },
        // 清空表单数据
        resetForm() {
            this.receipForm = {}
            this.show = false;
        },
        async addData() {
            this.resetForm.id ? this.title = '编辑入库' : this.title = '新增入库'
            const params = {
                pageIndex: 1,
                pageSize: 999,
            }
            //品牌
            const { data } = await productlist({ productName: "" })
            this.productlistdata = data.data
            const { data: list } = await orderquery(params)
            this.workList = list.data
            //单位
            const { data: list2 } = await productunitpagelist(params)
            this.productunitpagelist = list2.data

            //仓库 
            const { data: list3 } = await pagewarehouse(params)
            this.pagewarehouse = list3.list
            this.show = true
            if (!this.receipForm.id) {
                this.$set(this.receipForm, 'receiptDate', this.getCurrentYearMonth())
            }
        },
        getCurrentYearMonth() {
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            // 月份从 0 开始计数，所以要加 1，同时确保月份为两位数
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            // 确保日期为两位数
            const day = String(currentDate.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }

    }
};
</script>

<style></style>